import { Star } from "lucide-react";
import { COMPANY } from "../lib/constants";

export const GoogleBadge = ({ className = "", variant = "light" }) => {
  const isDark = variant === "dark";
  return (
    <a
      href={COMPANY.googleReviewUrl}
      target="_blank"
      rel="noreferrer"
      data-testid="google-rating-badge"
      data-cursor="hover"
      className={`inline-flex items-center gap-3 px-4 h-12 rounded-full border transition-all hover:-translate-y-0.5 ${
        isDark
          ? "bg-white/10 border-white/15 text-white hover:bg-white/15"
          : "bg-white border-black/10 text-black hover:border-black/30 hover:shadow-[0_10px_30px_-10px_rgba(0,0,0,0.18)]"
      } ${className}`}
    >
      <GoogleG className="w-5 h-5" />
      <div className="flex flex-col items-start leading-none">
        <div className="flex items-center gap-1.5">
          <span className="text-sm font-semibold">4,9</span>
          <span className="flex">
            {[0, 1, 2, 3, 4].map((i) => (
              <Star key={i} className={`w-3 h-3 ${isDark ? "fill-white text-white" : "fill-black text-black"}`} />
            ))}
          </span>
        </div>
        <span className={`font-mono text-[9px] tracking-[0.2em] uppercase mt-1 ${isDark ? "text-white/55" : "text-black/50"}`}>
          Google · 180+ Bewertungen
        </span>
      </div>
    </a>
  );
};

const GoogleG = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.99.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z" />
  </svg>
);
